<btn
    [id]="id() + '-sort-and-filter'"
    [label]="
        (filterOnly() ? 'uiKit.buttons.buttonSortAndFilter.filter' : 'uiKit.buttons.buttonSortAndFilter.sortAndFilter')
            | translate
    "
    [icon]="'fa-solid fa-chevron-right'"
    [iconPos]="'right'"
    [outlined]="true"
    [disabled]="disabled()"
    [whiteBg]="true"
    [size]="size()"
    (onClick)="onClick.emit($event)">
    <i class="fa-regular fa-sliders left-icon"></i>
</btn>
